import { Calculator } from './calculator';
import { Mode } from './constants';
import { StateManager } from './state-manager';
import { THEME_COLORS } from './theme-styles';
import { CalcItems } from './types';
import { getCookie } from './utils/cookieHelper';

declare global {
  interface Window {
    calculatorState: string;
    CheckoutUtility: typeof CheckoutUtility | any;
  }
}
type SHOP_CODE = 'ex' | 'mi' | 'vt' | 'ap';

type StoresConfig = {
  designToolUrl: string;
  portalUrl: string;
  apiUrl: string;
  calculatorAPIUrl: string;
  storageBucketUrl: string;
};

type Config = {
  adminUrl: string;
  ex: StoresConfig;
  mi: StoresConfig;
  vt: StoresConfig;
  ap: StoresConfig;
};

export const config: Record<string, Config> = {
  local: {
    adminUrl: 'https://3d-dashboard.dev.truetale.io',
    ex: {
      designToolUrl: 'http://localhost:4200/design/projects',
      portalUrl: 'http://localhost:4200/account/projects',
      apiUrl: 'http://localhost:3002/api/design-store',
      storageBucketUrl: 'https://media.dev.truetale.io',
      calculatorAPIUrl: 'http://localhost:3002/api/design-store',
    },
    mi: {
      designToolUrl: 'http://localhost:4200/design/projects',
      portalUrl: 'http://localhost:4200/account/projects',
      apiUrl: 'http://localhost:3002/api/design-store',
      storageBucketUrl: 'https://media.dev.truetale.io',
      calculatorAPIUrl: 'http://localhost:3002/api/design-store',
    },
    vt: {
      designToolUrl: 'http://localhost:4200/design/projects',
      portalUrl: 'http://localhost:4200/account/projects',
      apiUrl: 'http://localhost:3002/api/design-store',
      storageBucketUrl: 'https://media.dev.truetale.io',
      calculatorAPIUrl: 'http://localhost:3002/api/design-store',
    },
    ap: {
      designToolUrl: 'http://localhost:4200/design/projects',
      portalUrl: 'http://localhost:4200/account/projects',
      apiUrl: 'http://localhost:3002/api/design-store',
      storageBucketUrl: 'https://media.dev.truetale.io',
      calculatorAPIUrl: 'http://localhost:3002/api/design-store',
    },
  },
  dev: {
    adminUrl: 'https://3d-dashboard.dev.truetale.io',
    ex: {
      designToolUrl: 'https://expo.dev.truetale.io/design/projects',
      portalUrl: 'https://expo.dev.truetale.io/account/projects',
      apiUrl: 'https://api.dev.truetale.io/api/design-store',
      storageBucketUrl: 'https://media.dev.truetale.io',
      calculatorAPIUrl: 'https://scripts.dev.truetale.io/api/design-store',
    },
    mi: {
      designToolUrl: 'https://milo.dev.truetale.io/design/projects',
      portalUrl: 'https://milo.dev.truetale.io/account/projects',
      apiUrl: 'https://api.dev.truetale.io/api/design-store',
      storageBucketUrl: 'https://media.dev.truetale.io',
      calculatorAPIUrl: 'https://scripts.dev.truetale.io/api/design-store',
    },
    vt: {
      designToolUrl: 'https://vivid.dev.truetale.io/design/projects',
      portalUrl: 'https://vivid.dev.truetale.io/account/projects',
      apiUrl: 'https://api.dev.truetale.io/api/design-store',
      storageBucketUrl: 'https://media.dev.truetale.io',
      calculatorAPIUrl: 'https://scripts.dev.truetale.io/api/design-store',
    },
    ap: {
      designToolUrl: 'https://squad.dev.truetale.io/design/projects',
      portalUrl: 'https://squad.dev.truetale.io/account/projects',
      apiUrl: 'https://api.dev.truetale.io/api/design-store',
      storageBucketUrl: 'https://media.dev.truetale.io',
      calculatorAPIUrl: 'https://scripts.dev.truetale.io/api/design-store',
    },
  },
  qa: {
    adminUrl: 'https://3d-dashboard.qa.truetale.io',
    ex: {
      designToolUrl: 'https://expo.qa.truetale.io/design/projects',
      portalUrl: 'https://expo.qa.truetale.io/account/projects',
      apiUrl: 'https://api.qa.truetale.io/api/design-store',
      storageBucketUrl: 'https://media.qa.truetale.io',
      calculatorAPIUrl: 'https://scripts.qa.truetale.io/api/design-store',
    },
    mi: {
      designToolUrl: 'https://milo.qa.truetale.io/design/projects',
      portalUrl: 'https://milo.qa.truetale.io/account/projects',
      apiUrl: 'https://api.qa.truetale.io/api/design-store',
      storageBucketUrl: 'https://media.qa.truetale.io',
      calculatorAPIUrl: 'https://scripts.qa.truetale.io/api/design-store',
    },
    vt: {
      designToolUrl: 'https://vivid.qa.truetale.io/design/projects',
      portalUrl: 'https://vivid.qa.truetale.io/account/projects',
      apiUrl: 'https://api.qa.truetale.io/api/design-store',
      storageBucketUrl: 'https://media.qa.truetale.io',
      calculatorAPIUrl: 'https://scripts.qa.truetale.io/api/design-store',
    },
    ap: {
      designToolUrl: 'https://squad.qa.truetale.io/design/projects',
      portalUrl: 'https://squad.qa.truetale.io/account/projects',
      apiUrl: 'https://api.qa.truetale.io/api/design-store',
      storageBucketUrl: 'https://media.qa.truetale.io',
      calculatorAPIUrl: 'https://scripts.qa.truetale.io/api/design-store',
    },
  },
  prod: {
    adminUrl: 'https://admin.expoprint.io',
    ex: {
      designToolUrl: 'https://app.expoprint.io/design/projects',
      portalUrl: 'https://app.expoprint.io/account/projects',
      apiUrl: 'https://api.expoprint.io/api/design-store',
      storageBucketUrl: 'https://media.expoprint.io',
      calculatorAPIUrl: 'https://scripts.expoprint.io/api/design-store',
    },
    mi: {
      designToolUrl: 'https://app.miloprint.com/design/projects',
      portalUrl: 'https://app.miloprint.com/account/projects',
      apiUrl: 'https://api.miloprint.com/api/design-store',
      storageBucketUrl: 'https://media.miloprint.com',
      calculatorAPIUrl: 'https://scripts.miloprint.com//api/design-store',
    },
    vt: {
      designToolUrl: 'https://app.vividtents.com/design/projects',
      portalUrl: 'https://app.vividtents.com/account/projects',
      apiUrl: 'https://api.vividtents.com/api/design-store',
      storageBucketUrl: 'https://media.vividtents.com',
      calculatorAPIUrl: 'https://scripts.vividtents.com/api/design-store',
    },
    ap: {
      designToolUrl: 'https://app.squadmojo.com/design/projects',
      portalUrl: 'https://app.squadmojo.com/account/projects',
      apiUrl: 'https://api.squadmojo.com/api/design-store',
      storageBucketUrl: 'https://media.squadmojo.com',
      calculatorAPIUrl: 'https://scripts.squadmojo.com/api/design-store',
    },
  },
};

type CreateProjectInput = {
  ownerId?: string;
  bundleCode?: string;
  visitorId?: string;
  isDesignService?: boolean;
  turnaroundType: 'RUSH' | 'REG';
  items: Array<{
    key?: string;
    sku: string;
    qty: number;
  }>;
};

export type State = {
  designOnlineLoading: boolean;
  orderNowLoading: boolean;
  requestDesignServiceLoading: boolean;
  actionsDisabled: boolean;
};

const loadingSpinner = `
  <svg
    aria-hidden="true"
    class="checkout-btn-loading-spinner"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      fill="currentColor"
    />
    <path
      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      fill="currentFill"
    />
  </svg>
`;

const use3dDesignToolsFlash = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M34.6295 17.546C32.1292 15.1813 29.2348 13.3887 26.1164 11.9575C23.7045 10.8516 21.2338 9.89306 18.7271 9.02589C18.5495 8.96418 18.3703 8.88793 18.1858 8.86527C17.5177 8.78552 16.8978 9.20635 16.7052 9.84831C16.5224 10.4588 16.7523 11.0961 17.3145 11.4133C17.6084 11.5798 17.9408 11.6811 18.258 11.8045C20.0564 12.5058 21.87 13.1734 23.6522 13.9131C26.8207 15.2285 29.7552 16.9361 32.3434 19.2136C33.6117 20.3299 34.6704 21.6121 35.4497 23.0997C36.8977 25.8614 37.3511 28.7476 36.3774 31.7806C35.9333 33.1629 35.2989 34.4462 34.4759 35.6393C33.5464 36.9873 32.4615 38.2049 31.2329 39.281C29.8373 40.5044 28.3991 41.6806 26.9778 42.8749C26.7177 43.0938 26.4249 43.2823 26.1932 43.5274C25.7026 44.0442 25.6741 44.745 26.0809 45.2944C26.4656 45.8118 27.2129 45.9899 27.8159 45.682C28.0499 45.5621 28.2682 45.4026 28.4696 45.2333C30.1772 43.7916 31.9052 42.3732 33.5762 40.8891C34.8544 39.7529 35.952 38.4422 36.9013 37.0163C38.2632 34.9711 39.2078 32.7594 39.5804 30.3103C39.61 29.6678 39.6839 29.0241 39.6642 28.3827C39.5254 24.0588 37.734 20.4823 34.6295 17.546Z" fill="#CF1322"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0141 15.8151C16.3582 14.9363 15.6574 14.0883 15.044 13.1797C14.5173 12.3993 14.04 11.5757 13.6332 10.7271C13.3777 10.1929 13.2241 9.58525 13.1455 8.99562C13.0162 8.01841 13.451 7.38341 14.4189 7.15412C15.0353 7.00746 15.6994 6.91666 16.3227 6.98183C17.4471 7.09883 18.5588 7.33979 19.6705 7.55221C20.1146 7.63779 20.5435 7.80191 20.9847 7.90491C21.8292 8.10104 22.4828 7.77279 22.7237 7.05283C22.9839 6.27587 22.6318 5.59954 21.7873 5.25787C21.6825 5.21479 21.5743 5.17875 21.4642 5.15137C20.3281 4.8685 19.1914 4.58741 18.2533 4.35516C17.3634 4.28125 16.6871 4.20383 16.0078 4.17358C15.172 4.13633 14.3479 4.24808 13.5447 4.49308C11.4111 5.14496 10.1894 6.91896 10.3465 9.13296C10.4065 9.9705 10.5805 10.7859 10.9402 11.5436C11.3121 12.3282 11.6729 13.1314 12.1566 13.8467C13.0465 15.1609 14.0179 16.4186 14.9648 17.6938C15.0981 17.8736 15.2622 18.0401 15.4415 18.1745C15.9013 18.5191 16.5741 18.511 17.035 18.1798C17.5524 17.8079 17.7614 17.1548 17.5041 16.5711C17.3855 16.2994 17.1934 16.0555 17.0141 15.8151Z" fill="#CF1322"/>
</svg>`;

export default class CheckoutUtility {
  public stateMng: StateManager<State>;
  protected calculator: Calculator;
  protected config: Config;

  constructor(
    protected code: string,
    protected mode: Mode,
    stage: keyof typeof config,
    protected shopCode: string,
    calculator?: Calculator,
    protected enablePublicModal?: boolean,
  ) {
    this.config = config[stage];

    this.setCSSVariablesBasedOnShopCode();

    if (calculator) {
      this.calculator = calculator;
    } else {
      const splittedCode = code?.split(':::');

      //'CHECKERED_KIT:::PS=CHECKERED-CT=TOKYO'
      const defaultPatternSet =
        splittedCode?.length > 1 ? +splittedCode[1]?.split('-')[0]?.split(':')[1] : undefined;
      const defaultColorTheme =
        splittedCode?.length > 1 ? +splittedCode[1]?.split('-')[1]?.split(':')[1] : undefined;
      this.calculator = new Calculator(splittedCode[0], mode, {
        calculatorAPIUrl: this.config[this.shopCode as SHOP_CODE].calculatorAPIUrl,
        apiUrl: config[stage][shopCode as SHOP_CODE].apiUrl,
        adminUrl: config[stage].adminUrl,
        stage,
        defaultPatternSet,
        defaultColorTheme,
        shopCode: this.shopCode,
        enablePublicModal: this.enablePublicModal,
      });
    }

    this.stateMng = new StateManager<State>({
      designOnlineLoading: false,
      orderNowLoading: false,
      requestDesignServiceLoading: false,
      actionsDisabled: true,
    });
    this.stateMng.subscribe('designOnlineLoading', this.__renderDesignOnlineLoading, this);
    this.stateMng.subscribe('orderNowLoading', this.__renderOrderNowLoading, this);
    this.stateMng.subscribe(
      'requestDesignServiceLoading',
      this.__renderRequestDesignServiceLoading,
      this,
    );
    this.stateMng.subscribe('actionsDisabled', this.__renderActionsState, this);
    this.calculator.stateMng.subscribe('calcItems', this.detectIsntAllNone, this);

    try {
      window.addEventListener('on3DModelLoaded', (_) => {
        this.registerWindowEvents();
      });
      window.calculatorState = 'loaded';
      window.dispatchEvent(new Event('checkoutUtilityReady'));
    } catch (e) {
      console.error('Failed to register window events', e);
    }
  }

  protected setCSSVariablesBasedOnShopCode() {
    const root = document.documentElement;
    const shopCode = this.shopCode as SHOP_CODE;
    const colors = THEME_COLORS[shopCode || 'ex'];

    root.style.setProperty('--primary-color', colors.primary);
    root.style.setProperty('--secondary-color', colors.secondary);
    root.style.setProperty('--footer-color', colors.footer);
    root.style.setProperty('--secondary-darker', colors.secondaryDarker);
    root.style.setProperty('--primary-darker', colors.primaryDarker);
    root.style.setProperty('--primary-darker2', colors.primaryDarker2);
    root.style.setProperty('--hover-item-color', colors.hoverItem);
  }

  protected registerWindowEvents() {
    try {
      const registerDispatchers = (rawData: any) => {
        console.log('rawData:', rawData);
        const total =
          this.calculator.stateMng.get('total') * this.calculator.stateMng.get('currency')?.rate;
        // dispatch initialApiData event
        window.dispatchEvent(
          new CustomEvent('initialApiData', {
            detail: {
              apiData: rawData,
              calcState: this.calculator.stateMng.get('calcItems'),
              totalPrice: total,
              symbol: this.calculator.stateMng.get('currency')?.symbol,
            },
          }),
        );

        this.calculator.stateMng.subscribe('total', (total) =>
          window.dispatchEvent(
            new CustomEvent('totalPrice', {
              detail: {
                totalPrice: total * this.calculator.stateMng.get('currency')?.rate,
                symbol: this.calculator.stateMng.get('currency')?.symbol,
              },
            }),
          ),
        );

        this.calculator.stateMng.subscribe(
          'calcItems',
          (calcItems) => {
            window.dispatchEvent(
              new CustomEvent('syncCalcData', {
                detail: {
                  data: {
                    ...calcItems,
                    colorTheme: this.calculator.stateMng.get('selectedColorTheme'),
                    patternSet: this.calculator.stateMng.get('selectedPatternSet'),
                  },
                },
              }),
            );
          },
          this,
          'diff',
        );
      };

      const rawData = this.calculator.stateMng.get('rawData');
      console.log('rawData', rawData);
      // check if data exists
      if (rawData) {
        registerDispatchers(rawData);
      } else {
        this.calculator.stateMng.subscribe('rawData', registerDispatchers);
        window.addEventListener('initialApiData', (_: Event) => {
          this.calculator.stateMng.unsubscribe('rawData', registerDispatchers);
        });
      }
    } catch (e) {
      console.error('Failed to register window events', e);
    }
  }

  public render(containerId: string) {
    this.calculator.render(containerId);
    this.calculator.stateMng.subscribe('calcItems', this.renderActions, this);
  }

  protected renderActions() {
    this.calculator.setActions(this.getActionsDOMTree());
  }

  protected createProject(creationOrigin: 'DT' | 'PDP' | 'DS') {
    const calcResult = this.calculator.submit();

    return fetch(`${this.config[this.shopCode as SHOP_CODE].apiUrl}/projects/create-v2`, {
      method: 'POST',
      body: JSON.stringify(<CreateProjectInput>{
        bundleCode: this.mode === Mode.BUNDLE ? this.code : undefined,
        visitorId: getCookie('visitor_id') || undefined,
        shopCode: this.shopCode,
        currencyCode: this.calculator.stateMng.get('currency')?.code,
        isApparel: this.calculator.stateMng.get('isApparel'),
        patternSetId: this.calculator.stateMng.get('selectedPatternSet')?.id,
        colorThemeId: this.calculator.stateMng.get('customColorTheme')
          ? null
          : this.calculator.stateMng.get('selectedColorTheme')?.id,
        turnaroundType: calcResult.turnaroundType.toUpperCase() as 'RUSH' | 'REG',
        creationOrigin,
        initialPage: getCookie('IPU') || undefined,
        items: Object.keys(calcResult.items).map((key) => {
          const item = calcResult.items[key];
          return { key: key, qty: item.qty, sku: item.sku };
        }),
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((res) => (res.status === 201 ? res.json() : new Error('Failed to create project')))
      .catch((e) => {
        console.error('Failed to create project', e);
      });
  }

  protected detectIsntAllNone(calcItems: CalcItems) {
    this.stateMng.set(
      'actionsDisabled',
      Object.values(calcItems.products).every((prod) => prod && !prod.selected),
    );
  }

  protected __renderDesignOnlineLoading(loading: State['designOnlineLoading']) {
    const labelEl = document.getElementById('online-design-label');
    const bundleShortTitle = this.calculator.stateMng.get('bundleShortTitle');
    const singleTitle = this.calculator.stateMng.get('title').split('Customize Your ')[1];
    if (labelEl)
      labelEl.innerHTML = loading
        ? loadingSpinner
        : `<strong>Next: </strong> Design Your ${this.calculator.mode === Mode.BUNDLE ? bundleShortTitle : singleTitle} in 3D`;

    const mobileLabelEl = document.getElementById('online-design-label-mobile');
    if (mobileLabelEl)
      mobileLabelEl.innerHTML = loading
        ? loadingSpinner
        : `<strong>Next: </strong> Design on Your Mobile`;
  }

  protected __renderRequestDesignServiceLoading(loading: State['requestDesignServiceLoading']) {
    const labelEl = document.getElementById('request-design-service-label');
    const labelElMobile = document.getElementById('request-design-service-label-mobile');
    const bundleShortTitle = this.calculator.stateMng.get('bundleShortTitle');
    const singleTitle = this.calculator.stateMng.get('title').split('Customize Your ')[1];
    if (labelEl)
      labelEl.innerHTML = loading
        ? loadingSpinner
        : `Let Us Design Your ${this.calculator.mode === Mode.BUNDLE ? bundleShortTitle : singleTitle} for FREE!`;
    if (labelElMobile)
      labelElMobile.innerHTML = loading
        ? loadingSpinner
        : `<strong>Next: </strong> Get Your FREE Custom Design`;
  }

  private __renderOrderNowLoading(loading: State['orderNowLoading']) {
    const isApparel = this.calculator.stateMng.get('isApparel');
    const labelEl = document.getElementById('order-now-label');
    const mobileLabelEl = document.getElementById('order-now-label-mobile');
    const offlineLabelEl = document.getElementById('offline-print-templates');
    const nonePrintableLabelEl = document.getElementById('order-now-label-none-printable');
    if (labelEl)
      labelEl.innerHTML = loading
        ? loadingSpinner
        : isApparel
          ? 'Add to Cart'
          : 'Get Print Templates';
    if (nonePrintableLabelEl)
      nonePrintableLabelEl.innerHTML = loading ? loadingSpinner : 'Add to Cart';
    if (mobileLabelEl)
      mobileLabelEl.innerHTML = loading ? loadingSpinner : 'Order Now & Design Later';
    if (offlineLabelEl)
      offlineLabelEl.innerHTML = loading
        ? loadingSpinner
        : isApparel
          ? 'Add to Cart'
          : 'Get Print Templates';
  }

  protected __renderActionsState(disabled: boolean) {
    const actions = document.querySelectorAll<HTMLButtonElement>('.action');
    actions.forEach((action) => {
      action.disabled = disabled;
    });
  }

  protected __mobileActionsDOMTree(
    actionsDisabled: boolean,
    isPrintable: boolean,
    disableDesignService: boolean,
    shortTitle: string,
    isApparel: boolean,
  ) {
    return isPrintable
      ? [
          {
            tag: 'div',
            children: [
              !disableDesignService
                ? {
                    tag: 'p',
                    attributes: {
                      style: 'margin-bottom: 4px; color: #515151; font-size:15px',
                    },
                    children: [`We design your ${shortTitle} at no cost`],
                  }
                : '',
              !disableDesignService
                ? {
                    tag: 'button',
                    attributes: {
                      id: 'request-design-service-label-mobile',
                      title: 'Request a FREE Custom Design',
                      class: 'bg-yellow action',
                      disabled: actionsDisabled ? 'disabled' : undefined,
                    },
                    events: {
                      click: () => {
                        this.stateMng.set('requestDesignServiceLoading', true);
                        this.stateMng.set('actionsDisabled', true);
                        this.createProject('DS')
                          .then((project) => {
                            const shopCode = this.shopCode as SHOP_CODE;
                            const portalUrl = this.config[shopCode || 'ex'].portalUrl;
                            window.location.href = portalUrl + `/${project?.id}`;
                            this.stateMng.set('requestDesignServiceLoading', false);
                            this.stateMng.set('actionsDisabled', false);
                          })
                          .catch(() => {
                            this.stateMng.set('requestDesignServiceLoading', false);
                            this.stateMng.set('actionsDisabled', false);
                          });
                      },
                    },
                    children: [
                      {
                        tag: 'strong',
                        attributes: { class: 'action-text' },
                        children: ['Next: '],
                      },
                      `Get Your FREE Custom Design`,
                    ],
                  }
                : '',
              !disableDesignService
                ? {
                    tag: 'p',
                    attributes: {
                      style:
                        'position:relative; transform: rotate(-2deg);display: flex; margin-top:16px; color: #cf1322; text-align: center; font-family: Nanum Pen Script; font-size: 20px; font-style: normal; font-weight: 400; line-height: normal;',
                    },
                    children: [
                      `Have our team design a PRO ${shortTitle} for you 100% FREE - No Obligation!`,
                      {
                        tag: 'img',
                        attributes: {
                          style: 'position: absolute;right: -25px; top: -35px',
                          src: URL.createObjectURL(
                            new Blob([use3dDesignToolsFlash], { type: 'image/svg+xml' }),
                          ),
                          alt: 'flash',
                        },
                      },
                    ],
                  }
                : '',
              {
                tag: 'div',
                children: [
                  !disableDesignService
                    ? {
                        tag: 'p',
                        attributes: {
                          style:
                            'margin-bottom: 4px; margin-top: 32px; color: #515151; font-size:15px',
                        },
                        children: [
                          isApparel ? 'Looks good to you?' : `Want to design on your computer?`,
                        ],
                      }
                    : '',
                  {
                    tag: 'button',
                    attributes: {
                      id: 'order-now-label-mobile',
                      title: isApparel ? 'Looks good to you?' : 'Order Now & Design Later',
                      class: 'action',
                      disabled: actionsDisabled ? 'disabled' : undefined,
                    },
                    events: {
                      click: () => {
                        this.stateMng.set('orderNowLoading', true);
                        this.stateMng.set('actionsDisabled', true);
                        this.createProject('PDP')
                          .then((project) => {
                            const ukShop = this.calculator.stateMng.get('currency')?.code == 'GBP';
                            const url = new URL(window.location.href);
                            url.pathname = ukShop
                              ? '/en-uk/pages/add-to-cart'
                              : '/pages/add-to-cart';
                            url.searchParams.set('projectId', project.id);
                            window.location.href = url.toString();
                            this.stateMng.set('orderNowLoading', false);
                            this.stateMng.set('actionsDisabled', false);
                          })
                          .catch(() => {
                            this.stateMng.set('orderNowLoading', false);
                            this.stateMng.set('actionsDisabled', false);
                          });
                      },
                    },
                    children: [isApparel ? 'Add to Cart' : 'Order Now, Design Later'],
                  },
                ],
              },
            ],
          },
        ]
      : [
          {
            tag: 'div',
            children: [
              {
                tag: 'button',
                attributes: {
                  id: 'order-now-label-none-printable',
                  title: 'Add to Cart',
                  class: 'action',
                  disabled: actionsDisabled ? 'disabled' : undefined,
                },
                events: {
                  click: () => {
                    this.stateMng.set('orderNowLoading', true);
                    this.stateMng.set('actionsDisabled', true);
                    this.createProject('PDP')
                      .then((project) => {
                        const ukShop = this.calculator.stateMng.get('currency')?.code == 'GBP';
                        const url = new URL(window.location.href);
                        url.pathname = ukShop ? '/en-uk/pages/add-to-cart' : '/pages/add-to-cart';
                        url.searchParams.set('projectId', project.id);
                        window.location.href = url.toString();
                        this.stateMng.set('orderNowLoading', false);
                        this.stateMng.set('actionsDisabled', false);
                      })
                      .catch(() => {
                        this.stateMng.set('orderNowLoading', false);
                        this.stateMng.set('actionsDisabled', false);
                      });
                  },
                },
                children: ['Add to Cart'],
              },
            ],
          },
        ];
  }

  protected getActionsDOMTree() {
    const calcItems = this.calculator.stateMng.get('calcItems');
    const actionsDisabled = this.stateMng.get('actionsDisabled');
    if (!calcItems) return [];
    const showDesignOnline = Object.values(calcItems.products).some((prod) => prod.printable);
    const hasCoBranding = Object.values(calcItems.products).some(
      (item) => item.selected === true && item.specs?.['COB']?.valueCode === 'YES',
    );
    const disableDesignService = this.calculator.stateMng.get('isDesignServiceDisabled');
    const isApparel = this.calculator.stateMng.get('isApparel');
    const isMobile = window.innerWidth <= 768;
    const bundleShortTitle = this.calculator.stateMng.get('bundleShortTitle');
    const singleTitle = this.calculator.stateMng.get('title').split('Customize Your ')[1];
    return isMobile
      ? this.__mobileActionsDOMTree(
          actionsDisabled,
          showDesignOnline,
          disableDesignService,
          bundleShortTitle ?? singleTitle,
          isApparel,
        )
      : [
          {
            tag: 'div',
            children: showDesignOnline
              ? [
                  {
                    tag: 'p',
                    attributes: {
                      style: 'margin-bottom: 4px; color: #515151',
                    },
                    children: [`Feeling creative?`],
                  },
                  {
                    tag: 'button',
                    attributes: {
                      class: 'bg-yellow action',
                      id: 'online-design-label',
                      title: 'Design Your Booth in 3D',
                      disabled: actionsDisabled ? 'disabled' : undefined,
                    },
                    events: {
                      click: () => {
                        this.stateMng.set('designOnlineLoading', true);
                        this.stateMng.set('actionsDisabled', true);
                        this.createProject('DT')
                          .then((project: any) => {
                            if (project) {
                              const shopCode = this.shopCode as SHOP_CODE;
                              let designToolUrl = this.config[shopCode || 'ex'].designToolUrl;
                              designToolUrl += '/' + project.id;
                              const customColorTheme =
                                this.calculator.stateMng.get('customColorTheme');
                              if (customColorTheme) {
                                const params = new URLSearchParams();
                                Object.entries(customColorTheme).forEach(([key, value]) => {
                                  params.append(key, value + '');
                                });
                                designToolUrl += `?${params.toString()}`;
                              }
                              if (this.enablePublicModal) {
                                designToolUrl += customColorTheme
                                  ? '&designMode=scratch'
                                  : '?designMode=scratch';
                              }
                              window.location.href = designToolUrl;
                              this.stateMng.set('designOnlineLoading', false);
                              this.stateMng.set('actionsDisabled', false);
                            }
                          })
                          .catch(() => {
                            this.stateMng.set('designOnlineLoading', false);
                            this.stateMng.set('actionsDisabled', false);
                          });
                      },
                    },
                    children: [
                      {
                        tag: 'strong',
                        attributes: { class: 'action-text' },
                        children: ['Next: '],
                      },
                      `Design Your ${this.calculator.mode === Mode.BUNDLE ? bundleShortTitle : singleTitle} in 3D `,
                    ],
                  },
                  {
                    tag: 'p',
                    attributes: {
                      style:
                        'position:relative; transform: rotate(-2deg);display: flex; margin-top:16px; color: #cf1322; text-align: center; font-family: Nanum Pen Script; font-size: 19px; font-style: normal; font-weight: 400; line-height: normal;',
                    },
                    children: [
                      `Our 3D Design Tool is REALLY fun! Give it a try!`,
                      {
                        tag: 'img',
                        attributes: {
                          style: 'position: absolute;right: -35px; top: -35px',
                          src: URL.createObjectURL(
                            new Blob([use3dDesignToolsFlash], { type: 'image/svg+xml' }),
                          ),
                          alt: 'flash',
                        },
                      },
                    ],
                  },
                ]
              : [],
          },
          {
            tag: 'div',
            children: showDesignOnline
              ? [
                  !disableDesignService
                    ? {
                        tag: 'div',
                        children: [
                          {
                            tag: 'p',
                            attributes: {
                              style: 'margin-bottom: 4px; color: #515151',
                            },
                            children: [`Need a professional touch?`],
                          },
                          {
                            tag: 'button',
                            attributes: {
                              id: 'request-design-service-label',
                              title: 'Request a FREE Custom Design',
                              class: 'action',
                              disabled: actionsDisabled ? 'disabled' : undefined,
                            },
                            events: {
                              click: () => {
                                this.stateMng.set('requestDesignServiceLoading', true);
                                this.stateMng.set('actionsDisabled', true);
                                this.createProject('DS')
                                  .then((project) => {
                                    const shopCode = this.shopCode as SHOP_CODE;
                                    const portalUrl = this.config[shopCode || 'ex'].portalUrl;
                                    window.location.href = portalUrl + `/${project?.id}`;
                                    this.stateMng.set('requestDesignServiceLoading', false);
                                    this.stateMng.set('actionsDisabled', false);
                                  })
                                  .catch(() => {
                                    this.stateMng.set('requestDesignServiceLoading', false);
                                    this.stateMng.set('actionsDisabled', false);
                                  });
                              },
                            },
                            children: [
                              `Let Us Design Your ${this.calculator.mode === Mode.BUNDLE ? bundleShortTitle : singleTitle} for FREE!`,
                            ],
                          },
                        ],
                      }
                    : '',
                ]
              : [
                  {
                    tag: 'button',
                    attributes: {
                      class: 'action',
                      id: 'order-now-label-none-printable',
                      title: 'Add to Cart',
                      disabled: actionsDisabled ? 'disabled' : undefined,
                    },
                    events: {
                      click: () => {
                        this.stateMng.set('orderNowLoading', true);
                        this.stateMng.set('actionsDisabled', true);
                        this.createProject('PDP')
                          .then((project) => {
                            const ukShop = this.calculator.stateMng.get('currency')?.code == 'GBP';
                            const url = new URL(window.location.href);
                            url.pathname = ukShop
                              ? '/en-uk/pages/add-to-cart'
                              : '/pages/add-to-cart';
                            url.searchParams.set('projectId', project.id);
                            window.location.href = url.toString();
                            this.stateMng.set('orderNowLoading', false);
                            this.stateMng.set('actionsDisabled', false);
                          })
                          .catch(() => {
                            this.stateMng.set('orderNowLoading', false);
                            this.stateMng.set('actionsDisabled', false);
                          });
                      },
                    },
                    children: [`Add to Cart`],
                  },
                ],
          },
          {
            tag: 'div',
            attributes: {
              class: hasCoBranding ? 'hide-offline-text' : '',
            },
            children: [
              {
                tag: 'span',
                children: [
                  isApparel ? 'Looks good to you?' : 'Want to design offline?',
                  {
                    tag: 'a',
                    attributes: {
                      id: 'order-now-label',
                    },
                    events: {
                      click: () => {
                        this.stateMng.set('orderNowLoading', true);
                        this.stateMng.set('actionsDisabled', true);
                        this.createProject('PDP')
                          .then((project) => {
                            const ukShop = this.calculator.stateMng.get('currency')?.code == 'GBP';
                            const url = new URL(window.location.href);
                            url.pathname = ukShop
                              ? '/en-uk/pages/add-to-cart'
                              : '/pages/add-to-cart';
                            url.searchParams.set('projectId', project.id);
                            window.location.href = url.toString();
                            this.stateMng.set('orderNowLoading', false);
                            this.stateMng.set('actionsDisabled', false);
                          })
                          .catch(() => {
                            this.stateMng.set('orderNowLoading', false);
                            this.stateMng.set('actionsDisabled', false);
                          });
                      },
                    },
                    children: [isApparel ? 'Add to Cart' : 'Get Print Templates'],
                  },
                ],
              },
            ],
          },
        ];
  }
}

if (typeof window !== 'undefined') {
  window.CheckoutUtility = CheckoutUtility;
}
